<div>
  <div class="table-responsive">
    <table mat-table [dataSource]="grid" class="table-sm">
      <ng-container matColumnDef="action" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let grid" width="90px">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item color="primary" (click)="parent.download(grid)">
              <mat-icon fontSet="fas" fontIcon="fa-download"></mat-icon>
              <span>Download do Arquivo</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <ng-container matColumnDef="faturaLoteId">
        <th mat-header-cell *matHeaderCellDef>Lote</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.faturaLoteId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef>Usuário</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.usuario }}
        </td>
      </ng-container>
      <ng-container matColumnDef="clienteNome">
        <th mat-header-cell *matHeaderCellDef>Cliente</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.clienteNome }}
        </td>
      </ng-container>
      <ng-container matColumnDef="tipoFaturaDescricao">
        <th mat-header-cell *matHeaderCellDef>Tipo de Fatura</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.tipoFaturaDescricao }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dataInclusao">
        <th mat-header-cell *matHeaderCellDef>Data Inclusão</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.dataInclusao | date:'dd/MM/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="statusDescricao">
        <th mat-header-cell *matHeaderCellDef>Status Processamento</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.statusDescricao }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
<app-paginacao [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
  (page)="parent.onPageChange($event)" [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
<div class="align-footer">
  <button mat-stroked-button type="button" (click)="parent.excel()" [disabled]="isLoadingDownload">
    <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
      <mat-spinner diameter="20" color="dark"></mat-spinner>
      &nbsp; Baixando
    </span>
    <span *ngIf="!isLoadingDownload">
      <i class="fas fa-file-excel"></i> Download Excel
    </span>
  </button>
</div>
<div *ngIf="!isLoading && grid?.data?.length === 0" class="d-flex justify-content-center align-items-center"
  style="height: 100px">
  Nenhum registro encontrado!
</div>
